import React from 'react';
import { Plus, Trash2, Star, StarOff } from 'lucide-react';
import {
  Box,
  Typography,
  IconButton,
  Button,
  Divider,
  Tooltip
} from "@mui/material";
import { softColors } from "../../../styles/purchaseInvoices/pages/commonTableStyles.js";
import { 
  accountantsManagerStyles, 
  inputFocusStyle, 
  inputBlurStyle 
} from "../../../styles/purchaseInvoices/pages/accountantsManagerStyles.js";

const AccountantsManager = ({ 
  accountants = [], 
  onAdd, 
  onRemove, 
  onUpdate,
  isLoadingEmail 
}) => {
  const handleInputFocus = (e) => {
    e.target.style.borderColor = inputFocusStyle.borderColor;
    e.target.style.boxShadow = inputFocusStyle.boxShadow;
  };

  const handleInputBlur = (e) => {
    e.target.style.borderColor = inputBlurStyle.borderColor;
    e.target.style.boxShadow = inputBlurStyle.boxShadow;
  };

  return (
    <Box sx={accountantsManagerStyles.container}>
      <Box sx={accountantsManagerStyles.header}>
        <Typography variant="subtitle1" sx={accountantsManagerStyles.headerTitle}>
          מנהלות חשבונות
        </Typography>
        <Button
          onClick={onAdd}
          size="small"
          startIcon={<Plus size={16} strokeWidth={2.5} />}
          sx={accountantsManagerStyles.addButton}
        >
          הוסף מנהלת חשבונות
        </Button>
      </Box>
      <Box sx={accountantsManagerStyles.listContainer}>
        {accountants.map((acc, index) => (
          <Box key={index} sx={accountantsManagerStyles.card(acc.isPrimary)}>
            <Box sx={accountantsManagerStyles.cardHeader}>
              <Box sx={accountantsManagerStyles.cardHeaderLeft}>
                {acc.isPrimary && (
                  <Box sx={accountantsManagerStyles.starBadge}>
                    <Star size={16} fill={softColors.primary} color={softColors.primary} />
                  </Box>
                )}
                <Typography variant="body2" sx={accountantsManagerStyles.cardTitle(acc.isPrimary)}>
                  {acc.isPrimary ? 'מנהלת חשבונות ראשית' : `מנהלת חשבונות ${index + 1}`}
                </Typography>
              </Box>
              
              <Box sx={accountantsManagerStyles.cardHeaderRight}>
                <Tooltip title={acc.isPrimary ? "כבר מוגדרת כראשית" : "הגדר כמנהלת חשבונות ראשית"}>
                  <span>
                    <IconButton
                      size="small"
                      onClick={() => !acc.isPrimary && onUpdate(index, 'isPrimary', true)}
                      disabled={acc.isPrimary}
                      sx={accountantsManagerStyles.starButton(acc.isPrimary)}
                    >
                      {acc.isPrimary 
                        ? <Star size={20} fill={softColors.primary} /> 
                        : <StarOff size={20} />
                      }
                    </IconButton>
                  </span>
                </Tooltip>
                
                {accountants.length > 1 && (
                  <Tooltip title="מחק מנהלת חשבונות">
                    <IconButton
                      size="small"
                      onClick={() => onRemove(index)}
                      sx={accountantsManagerStyles.deleteButton}
                    >
                      <Trash2 size={20} />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </Box>

            <Divider sx={accountantsManagerStyles.divider} />

            <Box sx={accountantsManagerStyles.fieldsContainer}>

              <Box>
                <Typography component="label" variant="caption" sx={accountantsManagerStyles.label}>
                  שם:
                </Typography>
                <input
                  type="text"
                  placeholder="שם מנהלת החשבונות"
                  style={accountantsManagerStyles.inputBase}
                  value={acc.name || ""}
                  onChange={(e) => onUpdate(index, 'name', e.target.value)}
                  onFocus={handleInputFocus}
                  onBlur={handleInputBlur}
                />
              </Box>

              <Box>
                <Typography component="label" variant="caption" sx={accountantsManagerStyles.label}>
                  שם משתמש בפריוריטי: <span style={{ color: '#f44336' }}>*</span>
                </Typography>
                <input
                  type="text"
                  placeholder="שם המשתמש בפריוריטי"
                  style={accountantsManagerStyles.inputBase}
                  value={acc.accountant}
                  onChange={(e) => onUpdate(index, 'accountant', e.target.value)}
                  onFocus={handleInputFocus}
                  onBlur={handleInputBlur}
                />
              </Box>
              <Box>
                <Typography component="label" variant="caption" sx={accountantsManagerStyles.label}>
                  אימייל: <span style={{ color: '#f44336' }}>*</span>
                </Typography>
                <input
                  type="email"
                  placeholder="כתובת מייל"
                  style={accountantsManagerStyles.inputBase}
                  value={acc.email || ""}
                  onChange={(e) => onUpdate(index, 'email', e.target.value)}
                  onFocus={handleInputFocus}
                  onBlur={handleInputBlur}
                />
                {isLoadingEmail && (
                  <Typography variant="caption" sx={accountantsManagerStyles.loadingText}>
                    🔍 מחפש מייל אוטומטית...
                  </Typography>
                )}
              </Box>

              <Box sx={accountantsManagerStyles.checkboxContainer}>
                <input
                  type="checkbox"
                  id={`receiveEmails-${index}`}
                  checked={acc.receiveEmailNotifications !== false}
                  onChange={(e) => onUpdate(index, 'receiveEmailNotifications', e.target.checked)}
                  style={accountantsManagerStyles.checkboxStyle}
                />
                <label 
                  htmlFor={`receiveEmails-${index}`} 
                  style={accountantsManagerStyles.checkboxLabel}
                >
                  לקבל התראות מייל על חשבוניות
                </label>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AccountantsManager;